// queries.js

import { gql } from "@apollo/client";

export const GET_STATISTICS_QUERY = gql`
  query Statistics {
    activeClientsCount
    activeClientsLastMonthCount
    activeClientsThisMonthCount
    clientsWithExpiredCreditCount
    monthlyRevenue
    lastMonthRevenue
  }
`;
